import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import type { DriveStep } from 'driver.js';

/** Pasos del tour: textos claros y tono cercano, sin saturar. */
const steps: DriveStep[] = [
    {
        popover: {
            title: 'Bienvenido',
            description:
                'En esta pantalla administras las tipificaciones base del IVR: consultas con filtros, descarga de plantillas Excel e importación masiva. Puedes avanzar con «Siguiente» o cerrar cuando quieras.',
            side: 'over',
            align: 'center',
        },
    },
    {
        element: '#ivr-tb-filters',
        popover: {
            title: 'Filtros de búsqueda',
            description:
                'Combina tipo de tipificación, proceso, códigos, PQRST, cliente, tiempo de respuesta y estado activo para acotar el listado. Los filtros se aplican al cargar la tabla. «Limpiar filtros» deja todo en blanco de nuevo.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '#ivr-tb-btn-export',
        popover: {
            title: 'Exportar plantilla',
            description:
                'Descarga un Excel modelo según el tipo que elijas. Hay tres formatos: codificación de servicio, comercial y subtipificación hija. Elige el que corresponda a tu carga para que las columnas coincidan con lo que vas a importar después.',
            side: 'bottom',
            align: 'end',
        },
    },
    {
        element: '#ivr-tb-btn-import',
        popover: {
            title: 'Importar archivo',
            description:
                'Abre el asistente: elige primero el tipo de tipificación (debe coincidir con el Excel) y adjunta un solo archivo .xlsx; sin tipo no se puede cargar. Cada importación masiva desactiva los registros anteriores del mismo tipo; solo permanecen activos los de la última carga.',
            side: 'bottom',
            align: 'end',
        },
    },
    {
        element: '#ivr-tb-btn-sync-crm',
        popover: {
            title: 'Cargar data a CRMIcetex',
            description:
                'Usa este botón solo después de validar que cargaste los archivos correctos y que no existen registros duplicados. Al confirmar, se enviarán las tipificaciones activas al endpoint de sincronización con CRM.',
            side: 'bottom',
            align: 'end',
        },
    },
    {
        element: '#ivr-tb-grid',
        popover: {
            title: 'Resultados',
            description:
                'Aquí ves los registros paginados. Puedes ordenar y usar el filtro avanzado por columna donde esté disponible.',
            side: 'top',
            align: 'start',
        },
    },
    {
        element: '#ivr-tb-actions-header',
        popover: {
            title: 'Estado del registro',
            description:
                'En la columna Acciones, cada fila tiene un ícono: el check verde activa el registro y la X roja lo desactiva (según permisos). Pasa el cursor sobre el ícono para ver la acción; mientras se guarda, verás un indicador de carga.',
            side: 'bottom',
            align: 'center',
        },
    },
    {
        element: '#ivr-tb-btn-help',
        popover: {
            title: 'Repasar la guía',
            description:
                'Cuando lo necesites, vuelve a abrir este recorrido con este botón. ¡Listo!',
            side: 'bottom',
            align: 'center',
        },
    },
];

export const startIvrTypificationBaseTour = (): void => {
    const d = driver({
        showProgress: true,
        progressText: '{{current}} / {{total}}',
        nextBtnText: 'Siguiente',
        prevBtnText: 'Atrás',
        doneBtnText: 'Entendido',
        animate: true,
        smoothScroll: true,
        allowClose: true,
        overlayOpacity: 0.72,
        stagePadding: 8,
        steps,
    });
    d.drive();
};
